module.exports = __webpack_public_path__ + "static/EteTechnology_LOGO_YATAY-1326da0da67bdda1714062e49f806b26.png";